import React from 'react';
import { Table, Tag } from 'rsuite';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash/fp';

const { Cell } = Table;

export const StatusCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props} className="link-group">
    {rowData[dataKey] === 1 ? (
      <Tag color="green" size="lg">
        &#10004; Success
      </Tag>
    ) : (
      <Tag color="red" size="lg">
        &#x2716; Failed
      </Tag>
    )}
  </Cell>
);

StatusCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({
    actionName: PropTypes.string.isRequired,
    mainAction: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired
  })
};

StatusCell.defaultProps = {
  rowData: null
};

export const MessageCell = ({ rowData, dataKey, ...props }) => {
  const error = rowData[dataKey];
  const errors = error
    ? get('error', error) || [{ message: error.message }]
    : [];
  return (
    <Cell {...props}>
      {!isEmpty(errors) ? (
        <div style={{ color: 'red' }}>
          <p>ERROR:</p>
          {errors.map(({ message }, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <p key={`item-${i}`}> - {message}</p>
          ))}
        </div>
      ) : (
        'UPDATED'
      )}
    </Cell>
  );
};

MessageCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({
    actionName: PropTypes.string.isRequired,
    mainAction: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired
  })
};

MessageCell.defaultProps = {
  rowData: null
};
